module.exports = __webpack_public_path__ + "img/headphones.12584066.jpg";